
import { Options, prop, Vue } from "vue-class-component";
import DateRangePicker from "@/app/ui/components/date-range-picker/index.vue";
import { formatDateNumber } from "@/app/infrastructures/misc/Utils";
import { DownloadReportRequest } from "@/domain/entities/Kulioner";

class Props {
  buttonText = prop<string>({
    default: "",
    type: String
  });
  disabled = prop<boolean>({
    default: false,
    type: Boolean
  });
  maxRange = prop<number>({
    default: 31,
    type: Number
  });
}

@Options({
  components: {
    DateRangePicker
  },
  emits: ["update:modelValue", "download"]
})
class DownloadWithDateRange extends Vue.with(Props) {
  date = new DownloadReportRequest();

  get resolvedButtonText() {
    return this.buttonText || this.$t("pickupDashboard.downloadDataPickUp");
  }

  setDateRange([startDate, endDate]: string[]) {
    this.date.startDate = startDate;
    this.date.endDate = endDate;
  }
  onReset() {
    this.date = new DownloadReportRequest();

    const ref: any = this.$refs?.["courier-pickup-download-time-range-picker"];
    ref?.onSelectOption?.(ref?.options[0]);
    ref?.reset?.();
  }
  onDownload() {
    const dateConverted = new DownloadReportRequest({
      startDate: formatDateNumber(this.date.startDate),
      endDate: formatDateNumber(this.date.endDate)
    });
    this.$emit("download", dateConverted);

    // reset
    const ref: any = this.$refs?.["courier-pickup-download-time-range-picker"];
    ref?.onClickOutside?.();
    this.onReset();
  }
}
export default DownloadWithDateRange;
